import * as signalR from '@microsoft/signalr'
import { v4 as uuid4 } from 'uuid'

import Logger from '../../../utils/Logger'
import { getTokens } from '../../helpers/StorageHelper'
import { proxy } from '../../helpers/UrlHelper'
import { Rest } from '../../http'

const baseHubUrl = proxy(`/mbe/hubs`)
interface TRequest {
  resolve: (value?: unknown) => void
  reject: (value?: unknown) => void
  header: object
  payload: object
}

export class HubConnection {
  public connection?: signalR.HubConnection
  protected requests: { [key: string]: TRequest } = {}
  protected hub: string = ''
  protected delayAttempt: number = 0
  protected readyResolver: (value?: unknown) => void = () => undefined
  public ready = new Promise((r) => {
    this.readyResolver = r
  })

  public init(hub: string) {
    this.hub = hub
    this.create(hub)
    return this.ready
  }

  public call(method: string, payload: object = {}): object {
    const uuid = uuid4()
    const header = { uuid, method }
    this.send(method, payload)
    return new Promise((resolve, reject) => {
      this.requests[uuid] = { resolve, reject, header, payload }
    })
  }

  protected send(method: string, payload: object = {}) {
    this.ready
      .then(() => {
        if (this.connection) {
          // Logger.info(`${new Date().toISOString()} Api call: ${this.hub}/${method}`, {
          //   payload,
          // })
          this.connection.invoke(method, payload).catch(Logger.error)
        }
      })
      .catch(Logger.error)
  }

  protected resolveWhenConnected() {
    if (this.connection && this.connection.state) {
      this.delayAttempt = 0
      this.readyResolver()
    } else {
      setTimeout(() => {
        this.resolveWhenConnected()
      }, 1000)
    }
  }

  protected async create(hub: string) {
    const [token] = getTokens()

    if (token) {
      const result = await Rest.post({ url: proxy(`/mbe/api/v2/access/token/for/signalr`) })
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseHubUrl}/${hub}?_id=${encodeURIComponent(result)}`, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Warning)
        .build()

      this.connection.onclose(async () => {
        this.handleClose()
      })

      this.connection
        .start()
        .then(() => {
          this.resolveWhenConnected()
          // socketEventBus.notify('opened')
        })
        .catch((e) => {
          Logger.error('Connection issue', e)
          this.handleClose()
        })
    }
  }

  private handleClose = () => {
    Logger.debug('WS disconnected. Reconnect attempt.')
    // socketEventBus.notify('closed')
    if (this.delayAttempt) {
      setTimeout(() => {
        this.increaseDelay()
        this.create(this.hub)
      }, this.delayAttempt)
    } else {
      this.delayAttempt = 2000
      this.create(this.hub)
    }
  }

  private increaseDelay() {
    if (this.delayAttempt < 600000) {
      this.delayAttempt = this.delayAttempt + 2000
    } else {
      this.delayAttempt = 60000
    }
  }
}
